import { Component } from '@angular/core';

@Component({
  selector: 'app-list-icon',
  templateUrl: './list-icon.component.html',
  styleUrl: './list-icon.component.scss'
})
export class ListIconComponent {

}
